/**
 * Returns the meta list for the page based on route name
 *
 * @param {object} opts
 * @param {string} opts.routeName
 * @param {object} opts.pageCMS
 * @param {object} opts.defaultValue
 * @returns {*}
 */
const getSEOMetaData = function(opts = {}) {
  if (!opts || !opts.routeName || !opts.pageCMS) {
    return opts?.defaultValue ?? {};
  }

  const { routeName, pageCMS } = opts;

  switch (routeName) {
    case 'seo.city':
      return pageCMS.meta_city;
    case 'seo.state':
      return pageCMS.meta_state;
    case 'seo.address':
      return pageCMS.meta_address;
    case 'seo.phone':
      return pageCMS.meta_phone;
    default:
      return pageCMS.meta_root;
  }
};

export default getSEOMetaData;
